import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_pendings.metadata_title"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("my_pendings.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(VRow, { attrs: { dense: "" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("my_pendings.object_type"),
                            outlined: "",
                            dense: "",
                            items: _vm.object_types,
                          },
                          model: {
                            value: _vm.typeSelected,
                            callback: function ($$v) {
                              _vm.typeSelected = $$v
                            },
                            expression: "typeSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VTextField, {
                          attrs: {
                            label: _vm.$t("my_pendings.text_filter"),
                            placeholder: _vm.$t("my_pendings.text_filter"),
                            type: "text",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            },
                          },
                          model: {
                            value: _vm.text_filter,
                            callback: function ($$v) {
                              _vm.text_filter = $$v
                            },
                            expression: "text_filter",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _vm.typeSelected == 1
                  ? _c("list-tables-access-requested", {
                      ref: "listRef1",
                      attrs: {
                        typeFlow: _vm.TYPE_FLOW,
                        titlePage: _vm.TITLE_PAGE,
                        isOnlyView: _vm.is_view,
                      },
                      on: {
                        onItemAdded: function ($event) {
                          return _vm.onItemAdded()
                        },
                      },
                    })
                  : _vm._e(),
                _vm.typeSelected == 2
                  ? _c("list-datasource-access-requested", {
                      ref: "listRef2",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
                _vm.typeSelected == 3
                  ? _c("list-workbook-access-requested", {
                      ref: "listRef3",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
                _vm.typeSelected == 4
                  ? _c("list-dataset-access-requested", {
                      ref: "listRef4",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
                _vm.typeSelected == 5
                  ? _c("list-report-access-requested", {
                      ref: "listRef5",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
                _vm.typeSelected == 6
                  ? _c("list-report-access-requested-gds", {
                      ref: "listRef6",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
                _vm.typeSelected == 7
                  ? _c("list-datasource-access-requested-gds", {
                      ref: "listRef7",
                      attrs: { typeFlow: _vm.TYPE_FLOW },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_pendings.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.$t("my_pendings.object_type"),
                                    outlined: "",
                                    dense: "",
                                    items: _vm.object_types,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChangeType()
                                    },
                                  },
                                  model: {
                                    value: _vm.typeSelected,
                                    callback: function ($$v) {
                                      _vm.typeSelected = $$v
                                    },
                                    expression: "typeSelected",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: "Estado",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.status_list,
                                  },
                                  model: {
                                    value: _vm.status_filter,
                                    callback: function ($$v) {
                                      _vm.status_filter = $$v
                                    },
                                    expression: "status_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t("my_pendings.text_filter"),
                                    placeholder: _vm.$t(
                                      "my_pendings.text_filter"
                                    ),
                                    type: "text",
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.text_filter,
                                    callback: function ($$v) {
                                      _vm.text_filter = $$v
                                    },
                                    expression: "text_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CONFIRM_MASSIVE_APPROVE,
        attrs: {
          text:
            _vm.translate("frases.will_approve") +
            " " +
            _vm.rowsSelected.length +
            " " +
            _vm.translate("nouns.requests") +
            ", " +
            _vm.translate("warnings.are_you_sure"),
        },
        on: { onConfirm: _vm.onConfirmMassiveApprove },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }